import { createSelector } from 'reselect';
import { IAppState } from '../../../state/reducers';
import { IPublishSettings } from '../../../api/vault/publishEndpoints';
import { selectActivePublishSettings } from './selectActivePublishSettings';
import { UserRoles } from '../../../constants';
import { KeyRoleUserVaultRoles } from '../../../state/user/userOrgRole';

const userOrgRolesSelector = (state: IAppState) => state.user?.userOrgRole?.loginAs?.[KeyRoleUserVaultRoles];
const securityProfilesSelector = (state: IAppState) => state.securityProfiles?.idValueMapping ?? [];

const selectUserRole = createSelector(
  userOrgRolesSelector,
  securityProfilesSelector,
  (userOrgRoles, securityProfiles) => {
    if (!userOrgRoles) {
      return null;
    }

    const userRoleAndOrg = userOrgRoles.map((userOrgRole: any) => ({
      role: userOrgRole.roleName,
      orgId: userOrgRole.orgId,
    }));
    const isUserSuperAdmin = !!((userRoleAndOrg && userRoleAndOrg[0].role === UserRoles.VAULT_SUPER_ADMIN));
    if (!isUserSuperAdmin) {
      const userSecProfile = (securityProfiles)
        ? securityProfiles.filter((sProfile: any) => (sProfile.idm_org_id === userRoleAndOrg[0].orgId))
        : null;
      const securityProfile = userSecProfile.map((s: any) => s._id).toString();
      return { isUserSuperAdmin, securityProfile };
    }
    return { isUserSuperAdmin };
  },
);

export const selectUserPublishSettings = createSelector(
  selectActivePublishSettings,
  selectUserRole,
  (activePublishSettings, userRole) => {
    if (userRole && !userRole.isUserSuperAdmin && activePublishSettings) {
      return activePublishSettings.filter((s: any) => {
        if (s.settings.securityProfiles) {
          return s.settings.securityProfiles._id === userRole.securityProfile;
        }
        return false;
      });
    }

    return activePublishSettings;
  },
);
